module.exports = __webpack_public_path__ + "static/media/resume.daefb8de.pdf";